"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Rocket_exports = {};
__export(Rocket_exports, {
  default: () => Rocket_default
});
module.exports = __toCommonJS(Rocket_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13.708 10.352a2.234 2.234 0 1 0 3.159-3.158 2.234 2.234 0 0 0-3.16 3.158Zm2.31-.848a1.034 1.034 0 1 1-1.462-1.462 1.034 1.034 0 0 1 1.462 1.462Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M20.729 4.035a.813.813 0 0 0-.689-.706c-2.488-.361-7.884.412-11.727 5.986l-2.38.34a.823.823 0 0 0-.633.474l-1.78 3.917a.823.823 0 0 0 .75 1.164h1.773l2.807 2.807v1.774c0 .599.62.997 1.165.75l3.916-1.78a.823.823 0 0 0 .474-.634l.334-2.335c1.33-.726 2.946-2.231 4.17-4.198 1.286-2.063 2.18-4.697 1.82-7.559ZM9.214 10.123c3.397-5.03 8.096-5.848 10.357-5.641.222 2.407-.545 4.656-1.68 6.478-1.188 1.907-2.74 3.285-3.866 3.852a.826.826 0 0 0-.447.622l-.332 2.32-3.196 1.452v-1.345a.824.824 0 0 0-.24-.582l-3.03-3.028a.823.823 0 0 0-.582-.241H4.854l1.453-3.196 2.34-.335a.828.828 0 0 0 .567-.356Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M5.482 17.687a.6.6 0 1 0-.848-.848l-1.241 1.24a.6.6 0 1 0 .848.85l1.241-1.242Zm1.665.816a.6.6 0 0 1 0 .849l-1.241 1.24a.6.6 0 0 1-.849-.848l1.241-1.24a.6.6 0 0 1 .849 0Z"
    }
  )
);
const SvgRocket = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Rocket_default = SvgRocket;
